var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.feather_een{fill:#0B1719;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "feather_een",
    d: "M12,15.5c0-0.276,0.224-0.5,0.5-0.5H13c0.552,0,1,0.448,1,1v6.5c0,0.276-0.224,0.5-0.5,0.5 S13,22.776,13,22.5V16h-0.5C12.224,16,12,15.776,12,15.5z M17.5,16H18v6.5c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V16 c0-0.552-0.448-1-1-1h-0.5c-0.276,0-0.5,0.224-0.5,0.5C17,15.776,17.224,16,17.5,16z M30,8v19c0,1.657-1.343,3-3,3H5 c-1.657,0-3-1.343-3-3V8c0-1.657,1.343-3,3-3h1V4c0-1.105,0.895-2,2-2c1.105,0,2,0.895,2,2v1h12V4c0-1.105,0.895-2,2-2 c1.105,0,2,0.895,2,2v1h1C28.657,5,30,6.343,30,8z M23,7c0,0.551,0.449,1,1,1s1-0.449,1-1V4c0-0.551-0.449-1-1-1s-1,0.449-1,1V7z  M7,7c0,0.551,0.449,1,1,1s1-0.449,1-1V4c0-0.551-0.449-1-1-1S7,3.449,7,4V7z M28.976,27.242C28.447,27.708,27.76,28,27,28H5 c-0.76,0-1.447-0.292-1.976-0.758C3.145,28.229,3.98,29,5,29h22C28.02,29,28.855,28.229,28.976,27.242z M29,12H3v13 c0,1.103,0.897,2,2,2h22c1.103,0,2-0.897,2-2V12z M29,8c0-1.103-0.897-2-2-2h-1v1c0,1.105-0.895,2-2,2c-1.105,0-2-0.895-2-2V6H10v1 c0,1.105-0.895,2-2,2C6.895,9,6,8.105,6,7V6H5C3.897,6,3,6.897,3,8v3h26V8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanner);
export default __webpack_public_path__ + "static/media/planner.dffd4e8b541a266804b8543bf2ed96bd.svg";
export { ForwardRef as ReactComponent };